<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">登陆广东！刷掌支付规模化落地实现新突破</div>
      <div class="news-date">2023年9月11日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          在持续的技术创新及大规模应用实践下，微信刷掌支付落地再获新进展。自9月5日开始，
          <span class="mark-text highlight">深圳海岸城内所有街电大屏充电宝设备正式上线"微信刷掌租借"服务，标志着全国首家购物中心成功落地微信刷掌支付。</span>
        </p>
        <p>
          同时，广东地区超过1500家7-Eleven便利店也宣布上线微信刷掌支付服务，为用户提供更便捷、高效的支付方式。
        </p>
        <p>
          微信刷掌支付是一种基于手掌表皮掌纹和皮下掌静脉进行身份验证的新型支付方式。
          <span class="mark-text highlight">通过腾讯优图实验室先进的成像技术和AI算法，微信刷掌支付设备将用户手掌图像转化为数字特征，与预先注册的特征进行比对以确认用户身份，从而完成支付。</span>
        </p>
        <p>
          每个人的手纹和掌静脉信息都是独一无二的，即使是同卵双胞胎也有明显差异。这使得刷掌支付在身份验证方面具有出色的精确度。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news42/news42_1.gif"/>
          </div>
        </div>
        <p>
          对于可能影响识别精度的情况，如手掌脏污、遮挡或受伤，微信刷掌支付具备质量判断模块，能够避免异常手掌进入支付流程，提示用户无法使用。如果手掌因各种原因无法使用，用户可以切换到另一侧手掌，或者使用其他支付方式，如扫码或刷脸支付。
        </p>
        <p>
          在应对不法分子可能盗用用户手掌照片的情况下，微信刷掌支付采用可见光和红外光双模态采集手掌图像，防止了打印照片或屏幕的攻击。这样的多重防御能力和应对策略确保了用户数据的安全性。
        </p>
        <p>
          微信刷掌支付得以大规模成功落地背后，主要突破了三大技术难点。首先，为了在全国范围内服务数百万乃至更多用户，通过红外与彩色双摄像头同时采集掌纹+掌静脉的高质量成像，使用双模态融合识别提供百万级识别能力。在区分双胞胎等高相似人群方面，提出了全局与局部结合的识别方案，可以区分出掌纹掌静脉的局部细节差异。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news42/news42_2.png"/>
          </div>
        </div>
        <p>
          其次，为了提供极致的用户体验，
          <span class="mark-text highlight">优图实验室通过扩大视场角、抗运动模糊拍摄、实时质量优选等技术，可以支持用户在比较大的范围内高速移动手掌，尽可能少对用户的使用限制，提供更接近扫码的极致用户体验。</span>
          同时，结合本地识别、私有化部署等方案可以将整个使用过程控制在数百毫秒内。
        </p>
        <p>
          最后，在环境和人群适应性方面，结合光线滤除和可控补光能力，减轻了室内外光强差异、有水环境湿手掌、油性皮肤、弱静脉手掌等成像问题。针对各种场景掌纹数据稀少的问题，我们设计了一种逼真掌纹掌静脉的生成算法，可以实现稀缺数据的有效补充。
        </p>
        <p>
          目前，
          <span class="mark-text highlight">微信支付与腾讯优图实验室联合团队已发表近50项专利论文，制定了刷掌团体标准和企业标准，成为首个通过国家金融科技测评中心检测的刷掌产品。</span>
          未来，联合团队将继续研发和创新掌纹识别技术，探索更多产业场景的数字化方案，为用户提供更便捷、安全的支付方式。
        </p>

      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News42',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News42.vue